<template>
  <div :id="mapContainer" style="width: 50%; height: 100%"></div>
</template>

<script>
import { setColorByValue } from "../../util";

export default {
  props: {
    mapContainer: {
      type: String,
      required: true,
    },
    map: {
      type: Object,
    },
    popup: {
      type: Object,
    },
    data: {
      type: Array,
      default: () => [],
    },
    minmax: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: null,
    },
  },
  watch: {
    map(map) {
      if (map) this.initMap();
    },
    data(newdata) {
      this.repaintRegion(newdata);
    },
  },
  methods: {
    initMap() {
      const { map, mapContainer, data } = this;
      const country = mapContainer.split("-")[0];

      map.on("load", () => {
        map
          .setLayoutProperty("country-bubble-label", "visibility", "none")
          .setLayoutProperty("country-bubble", "visibility", "none")
          .setLayoutProperty("country-borders", "visibility", "none")
          .setLayoutProperty("subregion-shape", "visibility", "visible");

        map.setFilter("subregion-shape", [
          "all",
          ["match", ["get", "ISO3"], [country], true, false],
        ]);

        this.repaintRegion(data);

        map
          .on("mousemove", "subregion-shape", this.mousemove)
          .on("mouseleave", "subregion-shape", this.mouseleave);
      });
    },
    repaintRegion(data) {
      const { map, minmax } = this;
      map.setPaintProperty(
        "subregion-shape",
        "fill-color",
        setColorByValue(data, minmax, "subregion")
      );
    },
    mousemove(e) {
      const { map, popup, data } = this;
      let { sub_id } = e.features[0].properties;
      const dataRow = data.find((d) => d.sub_id === sub_id);

      map.getCanvas().style.cursor = "pointer";
      popup
        .setLngLat([e.lngLat.lng, e.lngLat.lat])
        .setHTML(this.formatTooltip(dataRow))
        .addTo(map);
    },
    mouseleave() {
      const { map, popup } = this;
      map.getCanvas().style.cursor = "";
      popup.remove();
    },
    formatTooltip(data) {
      return `
          <b><span>${data.subregion}</span></b><br/>
          Difference from country mean: ${data.diff}%<br/>
          Price: ${data.value} ${this.currency} per litre
        `;
    },
  },
};
</script>

<style></style>
